import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';

import { gettingStartedApiRef, GettingStartedClient } from './api';
import {
  academyContributorRouteRef,
  backstageDeveloperRouteRef,
  rootRouteRef,
  techDocsContributorRouteRef,
  templatesContributorRouteRef,
  uxHandbookRouteRef,
} from './routes';

export const gettingStartedPlugin = createPlugin({
  id: 'getting-started',
  apis: [
    createApiFactory({
      api: gettingStartedApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new GettingStartedClient({ discoveryApi, fetchApi }),
    }),
  ],
  routes: {
    root: rootRouteRef,
    academyContributor: academyContributorRouteRef,
    backstageDeveloper: backstageDeveloperRouteRef,
    techdocsContributor: techDocsContributorRouteRef,
    templatesContributor: templatesContributorRouteRef,
    uxHandbook: uxHandbookRouteRef,
  },
});

export const GettingStartedPage = gettingStartedPlugin.provide(
  createRoutableExtension({
    name: 'GettingStartedPage',
    component: () => import('./App').then(m => m.App),
    mountPoint: rootRouteRef,
  }),
);
